import React, { ReactNode, useState } from 'react';
import useKeywordDefinitionChecker from '@src/hooks/useKeywordDefinitionChecker';
import KeywordDefinitionModal from '@components/shared/KeywordDefinitionModal';

interface KeywordDefinitionProviderProps {
  children: ReactNode;
}

export const KeywordDefinitionProvider: React.FC<KeywordDefinitionProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentKeywordId, setCurrentKeywordId] = useState<string>('');
  const [currentKeyword, setCurrentKeyword] = useState<string>('');

  // 키워드 정의 확인 훅 사용 (체크 기능 활성화)
  useKeywordDefinitionChecker({
    enableChecking: true, // Provider에서만 체크 기능 활성화
    onDefinitionFound: (keywordId, keywordName) => {
      setCurrentKeywordId(keywordId);
      setCurrentKeyword(keywordName);
      setIsModalOpen(true);
    }
  });

  return (
    <>
      {children}
      {isModalOpen && currentKeywordId && (
        <KeywordDefinitionModal
          visible={isModalOpen}
          keyword={currentKeyword}
          keywordId={currentKeywordId}
          onClose={() => {
            setIsModalOpen(false);
            setCurrentKeywordId('');
            setCurrentKeyword('');
          }}
          onModify={() => {}}
        />
      )}
    </>
  );
};

export default KeywordDefinitionProvider;